var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messageTip"},[_c('div',{staticClass:"main"},[_c('p',[_vm._v("温馨提醒:"+_vm._s(_vm.message))]),_vm._v(" "),_c('div',{staticClass:"btn_box"},[_c('a',{staticClass:"btn",on:{"click":_vm.confirm}},[_vm._v("确定")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c33bbb1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/message.vue
// module id = null
// module chunks = 